import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=ea2841ee&scoped=true"
import script from "./ItemCreate.vue?vue&type=script&lang=js"
export * from "./ItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2841ee",
  null
  
)

export default component.exports